import React, { useState, useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { RhdetailTable } from "./RhdetailTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./rhdetailSlice";

export const RHDetailPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [rayonCode, setRayonCode] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [validFrom, setValidFrom] = useState("");
  const [validTo, setValidTo] = useState("");

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  const handleSearch = () => {
    const params = {
      rayonCode: rayonCode,
      customerCode: customerCode,
      validFrom: validFrom,
      validTo: validTo,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      rayonCode: rayonCode,
      customerCode: customerCode,
      validFrom: validFrom,
      validTo: validTo,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="RH Detail"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Rayon Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Rayon Code"
                    onChange={(e) => {
                      setRayonCode(e.target.value);
                    }}
                    value={rayonCode}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Code"
                    onChange={(e) => {
                      setCustomerCode(e.target.value);
                    }}
                    value={customerCode}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Valid From</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="date"
                    placeholder="Valid From"
                    onChange={(e) => {
                      setValidFrom(e.target.value);
                    }}
                    value={validFrom}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Valid To</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="date"
                    placeholder="Valid To"
                    onChange={(e) => {
                      setValidTo(e.target.value);
                    }}
                    value={validTo}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <RhdetailTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
